import { Typography } from 'design-component';
import React, { useState } from 'react';
import styled from 'styled-components'; // styled-components import
import { palette } from 'styles/color';

type TooltipProps = {
  text: string;
  children: React.ReactNode;
};

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <TooltipContainer onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      {children}
      <TooltipBox isVisible={isVisible}>
        <Typography component="div" size="14px" height="140%" weight={400} color={palette.white}>
          {text}
        </Typography>
      </TooltipBox>
    </TooltipContainer>
  );
};

export default Tooltip;

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipBox = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isVisible'].includes(prop as string),
})<{ isVisible: boolean }>`
  padding: 8px 14px;
  margin-top: 5px;
  position: absolute;
  top: 100%;
  left: 0%;
  background: ${palette.gray[800]};
  border-radius: 2px;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease-in-out;
  z-index: 1000;

  min-width: 301px;
  word-wrap: break-word; /* 줄바꿈 */
  word-break: break-word; /* 단어 단위로 줄바꿈 */
  white-space: normal; /* 텍스트가 줄바꿈될 수 있도록 설정 */
`;
